export const  VouchersRoutes = {
   
    voucherList: "/system/vouchers",
    createVoucher:"/system/vouchers/create",
    updateVoucher:"/system/vouchers/update",
    deleteVoucher:"/system/vouchers/delete",
    getVendorAuth:'vendors/continueRegistration',
    getVendorDetail:'vendors/profile',
    VendorForm:'/vendors/update',
    VendorLogin:'vendors/login',
    sendForgotPasswordOTP:'vendors/changePassword'
    
    
  };
    